import { render, staticRenderFns } from "./pushResultModal.vue?vue&type=template&id=4bf35b6d&scoped=true&"
import script from "./pushResultModal.vue?vue&type=script&lang=js&"
export * from "./pushResultModal.vue?vue&type=script&lang=js&"
import style0 from "./pushResultModal.vue?vue&type=style&index=0&id=4bf35b6d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf35b6d",
  null
  
)

export default component.exports